// extracted by mini-css-extract-plugin
module.exports = {"top-content":"forgot-password-m__top-content__2WLkz","label":"forgot-password-m__label__1pfr0","bottom-content":"forgot-password-m__bottom-content__3hann"};